import { render, staticRenderFns } from "./UpdateTaskDialog.vue?vue&type=template&id=4fd3cc1b"
import script from "./UpdateTaskDialog.vue?vue&type=script&lang=ts"
export * from "./UpdateTaskDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports